export type ResultType = "succeeded" | "faulted";

export interface BaseResult {
	readonly $type: ResultType;
}

export interface SuccessResult<T> extends BaseResult {
	$type: "succeeded";
	readonly value: T;
}

export interface ErrorResult extends BaseResult {
	$type: "faulted";
	error: string;
	status: number;
	data?: Record<string, any>;
}

export type IResult<T> = SuccessResult<T> | ErrorResult;

/**
 * Returns true if the result of the operation was faulted, false otherwise.
 * @param result
 */
export function isFaulted<T>(result: IResult<T>): result is ErrorResult {
	return result.$type === "faulted";
}

/**
 * Returns true if the result of the operation succeeded, false otherwise.
 * @param result
 */
export function isSucceeded<T>(result: IResult<T>): result is SuccessResult<T> {
	return result.$type === "succeeded";
}
